// import { createSlice } from '@reduxjs/toolkit';
// import { FormikValues } from 'formik';
// import axiosInstance from 'Services/APIService';
// import { AppDispatch } from 'store';
// import { DefaultRootStateProps } from 'types';
// import { AxiosError } from 'axios';

// // Utility function to fix date format
// const fixDateFormat = (dateString: string): string => {
//   if (!dateString) return dateString;
//   return dateString.replace(/T(\d{2})_(\d{2})_(\d{2})/, 'T$1:$2:$3');
// };

// const initialState: DefaultRootStateProps['calendar'] = {
//   error: null,
//   events: [],
//   servicesList: [],
//   staffList: {},
//   loading: false
// };

// const slice = createSlice({
//   name: 'calendarEvents',
//   initialState,
//   reducers: {
//     setLoading(state, action) {
//       state.loading = action.payload;
//     },
//     hasError(state, action) {
//       state.error = action.payload
//         ? {
//             message: action.payload.message || 'An error occurred',
//             code: action.payload.code,
//             status: action.payload.response?.status
//           }
//         : null;
//       state.loading = false;
//     },
//     getEventsSuccess(state, action) {
//       console.log('Reducer - Events:', action.payload);
//       state.events = action.payload.map((event: any) => ({
//         ...event,
//         manager_name: event.manager_name || event.manager || '',
//         support_worker: event.support_worker || event.support_worder || '',
//         client_name: event.client_name || '',
//         support_item_number: event.support_item_number || '',
//         start: event.start,
//         end: event.end
//       }));
//       state.loading = false;
//     },
//     addEventSuccess(state, action) {
//       const newEvent = {
//         ...action.payload,
//         manager_name: action.payload.manager_name || action.payload.manager || '',
//         support_worker: action.payload.support_worker || action.payload.support_worder || '',
//         client_name: action.payload.client_name || '',
//         support_item_number: action.payload.support_item_number || '',
//         start: action.payload.start,
//         end: action.payload.end
//       };
//       state.events = [...state.events, newEvent];
//       state.loading = false;
//     },
//     updateEventSuccess(state, action) {
//       state.events = action.payload.map((event: any) => ({
//         ...event,
//         manager_name: event.manager_name || event.manager || '',
//         support_worker: event.support_worker || event.support_worder || '',
//         client_name: event.client_name || '',
//         support_item_number: event.support_item_number || '',
//         start: event.start,
//         end: event.end
//       }));
//       state.loading = false;
//     },
//     removeEventSuccess(state, action) {
//       state.events = action.payload.map((event: any) => ({
//         ...event,
//         manager_name: event.manager_name || event.manager || '',
//         support_worker: event.support_worker || event.support_worder || '',
//         client_name: event.client_name || '',
//         support_item_number: event.support_item_number || '',
//         start: event.start,
//         end: event.end
//       }));
//       state.loading = false;
//     },
//     getServicesListSuccess(state, action) {
//       state.servicesList = Array.isArray(action.payload) ? action.payload : [];
//       state.loading = false;
//     },
//     fetchStaffByRolesSuccess(state, action) {
//       console.log('fetchStaffByRolesSuccess payload:', JSON.stringify(action.payload, null, 2));
//       const participantsList = action.payload?.participants_list || {};
//       const transformedStaffList = Object.keys(participantsList).reduce((acc, role) => {
//         acc[role] = participantsList[role].map((name: string, index: number) => ({
//           id: `${role}-${index}`,
//           name
//         }));
//         return acc;
//       }, {} as { [key: string]: { id: string; name: string }[] });
//       state.staffList = transformedStaffList;
//       state.loading = false;
//     },
//     fetchClientStaffSuccess(state, action) {
//       console.log('fetchClientStaffSuccess payload:', JSON.stringify(action.payload, null, 2));
//       const participantsList = action.payload?.participants_list || {};
//       const transformedStaffList = Object.keys(participantsList).reduce((acc, role) => {
//         acc[role] = participantsList[role].map(
//           (staff: { name: string; email: string }, index: number) => ({
//             id: `${role}-${index}`,
//             name: staff.name,
//             email: staff.email
//           })
//         );
//         return acc;
//       }, {} as { [key: string]: { id: string; name: string; email: string }[] });
//       state.staffList = transformedStaffList;
//       state.loading = false;
//     }
//   }
// });

// export default slice.reducer;

// export function getEvents(payload: any = null) {
//   return async (dispatch: AppDispatch) => {
//     dispatch(slice.actions.setLoading(true));
//     try {
//       let response = await axiosInstance.post('/calendar/events', payload);
//       dispatch(slice.actions.getEventsSuccess(response.data));
//     } catch (error: AxiosError | any) {
//       dispatch(
//         slice.actions.hasError({
//           message: error.message || 'Failed to fetch events',
//           code: error.code,
//           response: error.response
//         })
//       );
//     }
//   };
// }

// export function addEvent(event: FormikValues) {
//   return async (dispatch: AppDispatch) => {
//     dispatch(slice.actions.setLoading(true));
//     try {
//       const payload = {
//         ...event,
//         manager_name: event.manager || '',
//         support_worker: event.support_worder || '',
//         client_name: event.client_name || '',
//         support_item_number: event.support_item_number || '',
//         start: event.start,
//         end: event.end
//       };
//       console.log('addEvent payload:', JSON.stringify(payload, null, 2));
//       const response = await axiosInstance.post('/calendar/events/add', payload);
//       console.log('addEvent response:', JSON.stringify(response.data, null, 2));
//       dispatch(slice.actions.addEventSuccess(response.data));
//       dispatch(getEvents(payload));
//     } catch (error: AxiosError | any) {
//       console.error('addEvent error:', error);
//       dispatch(
//         slice.actions.hasError({
//           message: error.message || 'Failed to add event',
//           code: error.code,
//           response: error.response
//         })
//       );
//     }
//   };
// }

// export function updateEvent(event: FormikValues) {
//   return async (dispatch: AppDispatch) => {
//     dispatch(slice.actions.setLoading(true));
//     try {
//       const payload = {
//         ...event,
//         manager_name: event.manager || '',
//         support_worker: event.support_worder || '',
//         client_name: event.client_name || '',
//         support_item_number: event.support_item_number || '',
//         start: event.start,
//         end: event.end
//       };
//       console.log('updateEvent payload:', JSON.stringify(payload, null, 2));
//       const response = await axiosInstance.post('/calendar/events/update', payload);
//       console.log('updateEvent response:', JSON.stringify(response.data, null, 2));
//       dispatch(slice.actions.updateEventSuccess(response.data));
//       dispatch(getEvents(payload));
//     } catch (error: AxiosError | any) {
//       console.error('updateEvent error:', error);
//       dispatch(
//         slice.actions.hasError({
//           message: error.message || 'Failed to update event',
//           code: error.code,
//           response: error.response
//         })
//       );
//     }
//   };
// }

// export function removeEvent(payload: any = null) {
//   return async (dispatch: AppDispatch) => {
//     dispatch(slice.actions.setLoading(true));
//     try {
//       const deletePayload = {
//         ...payload,
//         manager_name: payload.manager || '',
//         support_worker: payload.support_worder || '',
//         client_name: payload.client_name || '',
//         support_item_number: payload.support_item_number || '',
//         start: payload.start,
//         end: payload.end
//       };
//       console.log('removeEvent payload:', JSON.stringify(deletePayload, null, 2));
//       const response = await axiosInstance.post('/calendar/events/delete', deletePayload);
//       console.log('removeEvent response:', JSON.stringify(response.data, null, 2));
//       dispatch(slice.actions.removeEventSuccess(response.data));
//     } catch (error: AxiosError | any) {
//       console.error('removeEvent error:', error);
//       dispatch(
//         slice.actions.hasError({
//           message: error.message || 'Failed to remove event',
//           code: error.code,
//           response: error.response
//         })
//       );
//     }
//   };
// }

// export function fetchStaffByRoles(payload: {
//   group_id: string;
//   service_name_id: string;
//   nested_component_id: string;
//   email_loggedIn_userEmail: string;
//   roles: string[];
//   client_name: string;
//   approved_user: string;
//   curr_loggIn_userRoles: string;
// }) {
//   return async (dispatch: AppDispatch) => {
//     dispatch(slice.actions.setLoading(true));
//     try {
//       const response = await axiosInstance.post('/staff_list/byRoles', payload);
//       console.log('fetchStaffByRoles response:', JSON.stringify(response.data, null, 2));
//       dispatch(slice.actions.fetchStaffByRolesSuccess(response.data));
//     } catch (error: AxiosError | any) {
//       console.error('fetchStaffByRoles error:', error);
//       dispatch(
//         slice.actions.hasError({
//           message: error.message || 'Failed to fetch staff list',
//           code: error.code,
//           response: error.response
//         })
//       );
//     }
//   };
// }

// export function fetchClientStaff(payload: {
//   group_id: string;
//   service_name_id: string;
//   nested_component_id: string;
//   email_loggedIn_userEmail: string;
//   roles: string[];
//   client_name: string;
//   approved_user: string;
//   curr_loggIn_userRoles: string;
// }) {
//   return async (dispatch: AppDispatch) => {
//     dispatch(slice.actions.setLoading(true));
//     try {
//       const response = await axiosInstance.post('/client/get-staff', payload);
//       console.log('fetchClientStaff response:', JSON.stringify(response.data, null, 2));
//       dispatch(slice.actions.fetchClientStaffSuccess(response.data));
//     } catch (error: AxiosError | any) {
//       console.error('fetchClientStaff error:', error);
//       dispatch(
//         slice.actions.hasError({
//           message: error.message || 'Failed to fetch client staff list',
//           code: error.code,
//           response: error.response
//         })
//       );
//     }
//   };
// }

// export function getServicesList(client_email: any) {
//   const project = JSON.parse(localStorage.getItem('selectedProject') || '{}') as {
//     projectId?: string;
//   };
//   const service = JSON.parse(localStorage.getItem('servicesState') || '{}') as {
//     selectedServiceTitle?: string;
//   };
//   return async (dispatch: AppDispatch) => {
//     dispatch(slice.actions.setLoading(true));
//     try {
//       const response = await axiosInstance.post('/get/services-list', {
//         group_id: project.projectId,
//         service_name_id: service.selectedServiceTitle,
//         client_email: client_email
//       });
//       let servicesData = response.data;
//       if (typeof servicesData === 'string') {
//         try {
//           servicesData = servicesData.replace(/NaN/g, 'null');
//           servicesData = JSON.parse(servicesData);
//         } catch (parseError) {
//           console.error('Error parsing services list:', parseError);
//           throw new Error('Invalid services list format');
//         }
//       }
//       if (!Array.isArray(servicesData)) {
//         console.warn('Services list is not an array:', servicesData);
//         servicesData = [];
//       }
//       console.log(
//         'getServicesList response:',
//         servicesData,
//         'isArray:',
//         Array.isArray(servicesData)
//       );
//       dispatch(slice.actions.getServicesListSuccess(servicesData));
//     } catch (error: AxiosError | any) {
//       console.error('getServicesList error:', error);
//       dispatch(
//         slice.actions.hasError({
//           message: error.message || 'Failed to fetch services list',
//           code: error.code,
//           response: error.response
//         })
//       );
//     }
//   };
// }



import { createSlice } from '@reduxjs/toolkit';
import { FormikValues } from 'formik';
import axiosInstance from 'Services/APIService';
import { AppDispatch } from 'store';
import { DefaultRootStateProps } from 'types';
import { AxiosError } from 'axios';

// Utility function to fix date format
const fixDateFormat = (dateString: string): string => {
  if (!dateString) return dateString;
  return dateString.replace(/T(\d{2})_(\d{2})_(\d{2})/, 'T$1:$2:$3');
};

const initialState: DefaultRootStateProps['calendar'] = {
  error: null,
  events: [],
  servicesList: [],
  staffList: {},
  loading: false
};

const slice = createSlice({
  name: 'calendarEvents',
  initialState,
  reducers: {
    setLoading(state, action) {
      state.loading = action.payload;
    },
    hasError(state, action) {
      state.error = action.payload
        ? {
            message: action.payload.message || 'An error occurred',
            code: action.payload.code,
            status: action.payload.response?.status
          }
        : null;
      state.loading = false;
    },
    getEventsSuccess(state, action) {
      console.log('Reducer - Events:', action.payload);
      state.events = action.payload.map((event: any) => ({
        ...event,
        manager_name: event.manager_name || event.manager || '',
        support_worker: event.support_worker || event.support_worder || '',
        client_name: event.client_name || '',
        support_item_number: event.support_item_number || '',
        start: event.start,
        end: event.end
      }));
      state.loading = false;
    },
    getServicesListSuccess(state, action) {
      state.servicesList = Array.isArray(action.payload) ? action.payload : [];
      state.loading = false;
    },
    fetchStaffByRolesSuccess(state, action) {
      console.log('fetchStaffByRolesSuccess payload:', JSON.stringify(action.payload, null, 2));
      const participantsList = action.payload?.participants_list || {};
      const transformedStaffList = Object.keys(participantsList).reduce((acc, role) => {
        acc[role] = participantsList[role].map((name: string, index: number) => ({
          id: `${role}-${index}`,
          name
        }));
        return acc;
      }, {} as { [key: string]: { id: string; name: string }[] });
      state.staffList = transformedStaffList;
      state.loading = false;
    },
    fetchClientStaffSuccess(state, action) {
      console.log('fetchClientStaffSuccess payload:', JSON.stringify(action.payload, null, 2));
      const participantsList = action.payload?.participants_list || {};
      const transformedStaffList = Object.keys(participantsList).reduce((acc, role) => {
        acc[role] = participantsList[role].map(
          (staff: { name: string; email: string }, index: number) => ({
            id: `${role}-${index}`,
            name: staff.name,
            email: staff.email
          })
        );
        return acc;
      }, {} as { [key: string]: { id: string; name: string; email: string }[] });
      state.staffList = transformedStaffList;
      state.loading = false;
    }
  }
});

export default slice.reducer;

export function getEvents(payload: any = null) {
  return async (dispatch: AppDispatch) => {
    dispatch(slice.actions.setLoading(true));
    try {
      let response = await axiosInstance.post('/calendar/events', payload);
      dispatch(slice.actions.getEventsSuccess(response.data));
    } catch (error: AxiosError | any) {
      dispatch(
        slice.actions.hasError({
          message: error.message || 'Failed to fetch events',
          code: error.code,
          response: error.response
        })
      );
    }
  };
}

export function addEvent(event: FormikValues) {
  return async (dispatch: AppDispatch) => {
    dispatch(slice.actions.setLoading(true));
    try {
      const payload = {
        ...event,
        manager_name: event.manager || '',
        support_worker: event.support_worder || '',
        client_name: event.client_name || '',
        support_item_number: event.support_item_number || '',
        start: event.start,
        end: event.end
      };
      console.log('addEvent payload:', JSON.stringify(payload, null, 2));
      await axiosInstance.post('/calendar/events/add', payload);
      console.log('addEvent success');
      dispatch(getEvents(payload));
    } catch (error: AxiosError | any) {
      console.error('addEvent error:', error);
      dispatch(
        slice.actions.hasError({
          message: error.message || 'Failed to add event',
          code: error.code,
          response: error.response
        })
      );
    }
  };
}

export function updateEvent(event: FormikValues) {
  return async (dispatch: AppDispatch) => {
    dispatch(slice.actions.setLoading(true));
    try {
      const payload = {
        ...event,
        manager_name: event.manager || '',
        support_worker: event.support_worder || '',
        client_name: event.client_name || '',
        support_item_number: event.support_item_number || '',
        start: event.start,
        end: event.end
      };
      console.log('updateEvent payload:', JSON.stringify(payload, null, 2));
      await axiosInstance.post('/calendar/events/update', payload);
      console.log('updateEvent success');
      dispatch(getEvents(payload));
    } catch (error: AxiosError | any) {
      console.error('updateEvent error:', error);
      dispatch(
        slice.actions.hasError({
          message: error.message || 'Failed to update event',
          code: error.code,
          response: error.response
        })
      );
    }
  };
}

export function removeEvent(payload: any = null) {
  return async (dispatch: AppDispatch) => {
    dispatch(slice.actions.setLoading(true));
    try {
      const deletePayload = {
        ...payload,
        manager_name: payload.manager || '',
        support_worker: payload.support_worder || '',
        client_name: payload.client_name || '',
        support_item_number: payload.support_item_number || '',
        start: payload.start,
        end: payload.end
      };
      console.log('removeEvent payload:', JSON.stringify(deletePayload, null, 2));
      await axiosInstance.post('/calendar/events/delete', deletePayload);
      console.log('removeEvent success');
      dispatch(getEvents(payload));
    } catch (error: AxiosError | any) {
      console.error('removeEvent error:', error);
      dispatch(
        slice.actions.hasError({
          message: error.message || 'Failed to remove event',
          code: error.code,
          response: error.response
        })
      );
    }
  };
}

export function fetchStaffByRoles(payload: {
  group_id: string;
  service_name_id: string;
  nested_component_id: string;
  email_loggedIn_userEmail: string;
  roles: string[];
  client_name: string;
  approved_user: string;
  curr_loggIn_userRoles: string;
}) {
  return async (dispatch: AppDispatch) => {
    dispatch(slice.actions.setLoading(true));
    try {
      const response = await axiosInstance.post('/staff_list/byRoles', payload);
      console.log('fetchStaffByRoles response:', JSON.stringify(response.data, null, 2));
      dispatch(slice.actions.fetchStaffByRolesSuccess(response.data));
    } catch (error: AxiosError | any) {
      console.error('fetchStaffByRoles error:', error);
      dispatch(
        slice.actions.hasError({
          message: error.message || 'Failed to fetch staff list',
          code: error.code,
          response: error.response
        })
      );
    }
  };
}

export function fetchClientStaff(payload: {
  group_id: string;
  service_name_id: string;
  nested_component_id: string;
  email_loggedIn_userEmail: string;
  roles: string[];
  client_name: string;
  approved_user: string;
  curr_loggIn_userRoles: string;
}) {
  return async (dispatch: AppDispatch) => {
    dispatch(slice.actions.setLoading(true));
    try {
      const response = await axiosInstance.post('/client/get-staff', payload);
      console.log('fetchClientStaff response:', JSON.stringify(response.data, null, 2));
      dispatch(slice.actions.fetchClientStaffSuccess(response.data));
    } catch (error: AxiosError | any) {
      console.error('fetchClientStaff error:', error);
      dispatch(
        slice.actions.hasError({
          message: error.message || 'Failed to fetch client staff list',
          code: error.code,
          response: error.response
        })
      );
    }
  };
}

export function getServicesList(client_email: any) {
  const project = JSON.parse(localStorage.getItem('selectedProject') || '{}') as {
    projectId?: string;
  };
  const service = JSON.parse(localStorage.getItem('servicesState') || '{}') as {
    selectedServiceTitle?: string;
  };
  return async (dispatch: AppDispatch) => {
    dispatch(slice.actions.setLoading(true));
    try {
      const response = await axiosInstance.post('/get/services-list', {
        group_id: project.projectId,
        service_name_id: service.selectedServiceTitle,
        client_email: client_email
      });
      let servicesData = response.data;
      if (typeof servicesData === 'string') {
        try {
          servicesData = servicesData.replace(/NaN/g, 'null');
          servicesData = JSON.parse(servicesData);
        } catch (parseError) {
          console.error('Error parsing services list:', parseError);
          throw new Error('Invalid services list format');
        }
      }
      if (!Array.isArray(servicesData)) {
        console.warn('Services list is not an array:', servicesData);
        servicesData = [];
      }
      console.log(
        'getServicesList response:',
        servicesData,
        'isArray:',
        Array.isArray(servicesData)
      );
      dispatch(slice.actions.getServicesListSuccess(servicesData));
    } catch (error: AxiosError | any) {
      console.error('getServicesList error:', error);
      dispatch(
        slice.actions.hasError({
          message: error.message || 'Failed to fetch services list',
          code: error.code,
          response: error.response
        })
      );
    }
  };
}